/* ---------- Grade system (German Abitur scale) ---------- */

export type GradeInfo = {
  grade: string
  label: string
  i18nKey: string
  min: number
  color: string
  bgColor: string
  textColor: string
  ringColor: string
}

export const GRADES: GradeInfo[] = [
  { grade: '1', label: 'Sehr gut', i18nKey: 'gradeExcellent', min: 85, color: 'bg-green-700', bgColor: 'bg-green-50 dark:bg-green-900/20', textColor: 'text-green-700 dark:text-green-400', ringColor: 'ring-green-500' },
  { grade: '2', label: 'Gut', i18nKey: 'gradeGood', min: 70, color: 'bg-green-500', bgColor: 'bg-green-50 dark:bg-green-900/15', textColor: 'text-green-600 dark:text-green-400', ringColor: 'ring-green-400' },
  { grade: '3', label: 'Befriedigend', i18nKey: 'gradeSatisfactory', min: 55, color: 'bg-yellow-500', bgColor: 'bg-yellow-50 dark:bg-yellow-900/15', textColor: 'text-yellow-600 dark:text-yellow-400', ringColor: 'ring-yellow-400' },
  { grade: '4', label: 'Ausreichend', i18nKey: 'gradeAdequate', min: 40, color: 'bg-orange-500', bgColor: 'bg-orange-50 dark:bg-orange-900/15', textColor: 'text-orange-600 dark:text-orange-400', ringColor: 'ring-orange-400' },
  { grade: '5', label: 'Mangelhaft', i18nKey: 'gradePoor', min: 20, color: 'bg-red-500', bgColor: 'bg-red-50 dark:bg-red-900/15', textColor: 'text-red-500 dark:text-red-400', ringColor: 'ring-red-400' },
  { grade: '6', label: 'Ungenügend', i18nKey: 'gradeFail', min: 0, color: 'bg-red-800', bgColor: 'bg-red-50 dark:bg-red-900/20', textColor: 'text-red-700 dark:text-red-400', ringColor: 'ring-red-600' },
]

export function getGrade(score: number): GradeInfo {
  return GRADES.find((g) => score >= g.min) ?? GRADES[GRADES.length - 1]
}

/* ---------- Dimension config ---------- */

export const DIMENSION_CONFIG: Record<string, { weight: number }> = {
  title: { weight: 0.20 },
  bullets: { weight: 0.20 },
  description: { weight: 0.10 },
  images: { weight: 0.20 },
  keywords: { weight: 0.10 },
  reviews: { weight: 0.10 },
  pricing: { weight: 0.05 },
  compliance: { weight: 0.05 },
}

export function scoreColor(score: number): string {
  if (score >= 80) return 'text-green-600 dark:text-green-400'
  if (score >= 60) return 'text-yellow-600 dark:text-yellow-400'
  return 'text-red-600 dark:text-red-400'
}
